import polyfill from './polyfill'; polyfill();
import 'isomorphic-fetch';
import 'babel-polyfill';
import React from "react";
import ReactDom from "react-dom";
import {
  Router,
  Route,
  Redirect,
  Link,
  IndexRoute,
  IndexRedirect,
  useRouterHistory,
  browserHistory
} from 'react-router';
import { Provider } from 'react-redux';
import Ga from 'react-router-google-analytics';
import './stylesheets/styles.scss';

///Bring in all of the components for our routes.
import {
  App,
  UI,
  Route404,
  Dashboard,
  DashboardSummary,
  Posts,
  PostsContainer,
  PostListContainer,
  EditPostContainer,
  CreatePostContainer,
  User,
  Maps,
  MapCreator,
  ClientsContainer,
  ClientsListView,
  ClientPermissions,
  ClientView,
  ClientTasks,
  ClientDamageIncidents,
  ClientInteractions,
  ClientContainer,
  ClientsMapView,
  ClientsCanvassingView,
  ClientsSettingsView,
  SalesRegionManager,
  FieldSettings,
  TypeSettings,
  PipelineBuilderSettings,
  ClientsUpload,
  ClientJobs,
  ClientIncident,
  JobView,
  CanvassingReport,
  MarkerUploadContainer,
  // Reports
  ReportsContainer,

  // Recovery,
  LiveWeatherCenter,
  NotificationsContainer,
  NotificationSettingsContainer,
  RoleManagement,
  SignIn,
  PlansContainer,
  HelpContainer,

  //Jobs and Leads,
  JobsContainer,
  OpportunitiesContainer,

  //Permissions routes.
  PermissionsContainer,

  // Settings
  SettingsContainer,
  IntegrationsContainer,


  //Sales Site
  SalesSiteManagerContainer,
  //Plans
  PlansList,
  CreatePlan,
  UpdatePlan,

  // Subscriptions
  SubscriptionsContainer,
  SubscriptionWizardContainer,
  SubscriptionDetailsView,

  // Error Logs
  ErrorLogsContainer
} from 'components';

import UsersContainer from 'components/users/usersContainer';

import {
  Account,
  AccountContainer
} from 'components/account';

import {
  displayNotice
} from 'actions';

/*******Create Redux Store********/
import {routerMiddleware, syncHistoryWithStore, routerReducer } from 'react-router-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import {rootSaga} from 'sagas'
import * as reducers from 'reducers';

var reducer = combineReducers(Object.assign({},reducers,{
  routing : routerReducer
}));

const middlewares = [];

const routerReduxMiddleware = routerMiddleware(browserHistory);
const sagaMiddleware = createSagaMiddleware();

middlewares.push(routerReduxMiddleware);
middlewares.push(thunkMiddleware);
middlewares.push(sagaMiddleware);

export const Store = createStore(
  reducer,
  {},
  compose(
    applyMiddleware(
      ...middlewares
    ),
    window.devToolsExtension && process.env.NODE_ENV !== 'production' ? window.devToolsExtension() : f => f
  )
)
sagaMiddleware.run(rootSaga);
const history = syncHistoryWithStore(browserHistory, Store);
/*******End Redux setup***********/

const entry = document.getElementById('entry-point');

window.Store = Store;
if(entry) {
  try {
    ReactDom.render(
    (
      <Provider store={Store}>
        <Router
          history={history}
          onUpdate={() => {
            process.env.NODE_ENV === 'production' ? ga('set', 'page', location.pathname) : ga('send','pageview');
            window.Intercom(location.pathname);
          }}
          >
          <Route path='/' component={App} >
            <IndexRedirect to='dashboard/summary'/>
            <Route path='canvassing-regions' component={SalesRegionManager} />
            <Route path='canvassing/upload' component={MarkerUploadContainer} />
            <Route path='sales-site' component={SalesSiteManagerContainer} />
            <Route path='sales-site/page/create' component={SalesSiteManagerContainer} />
            <Route path='sales-site/page/:pageID' component={SalesSiteManagerContainer} />
            <Route path='sales-site/page/:pageID/section/:sectionID' component={SalesSiteManagerContainer} />
            <Route path='sales-site/plans' component={PlansList} />
            <Route path='sales-site/plans/create' component={CreatePlan} />
            <Route path='sales-site/plans/update' component={UpdatePlan} />
            <Route path='sales-site/*' component={SalesSiteManagerContainer} />
            <Route path='dashboard' component={Dashboard}>
              <Route path='summary' component={DashboardSummary}/>
            </Route>
            <Route path='signin' component={SignIn} />
            <Route path='posts' component={PostsContainer}>
              <IndexRoute component={PostListContainer} />
              <Route path="create" component={CreatePostContainer} />
              <Route path="edit/:id" component={EditPostContainer} />
            </Route>
            <Route path='notifications' component={NotificationsContainer} />
            <Route path='users' component={UsersContainer}/>
            {/*<Route path='role-management' component={RoleManagement} />*/}
            <Route path='account' component={AccountContainer}>
              <Route path='billing' component={Account} />
              <Route path=':id' component={User.ViewMyAccount} />
            </Route>
            <Route path='map' component={Maps.MapsContainer}>
              <Redirect from='search' to='/clients/map' />
              <Redirect from='search/:mapID' to='/clients/map/:mapID' />
              <IndexRoute component={ClientsMapView} />
              <Route path='create' component={MapCreator} /> {/*Consider creation....may be moved to storms.*/}
              <Route path='edit/:id' component={Maps.Edit} /> {/*This will most likely be removed. We are not "creating" maps anymore. We create storms that have all the swaths.*/}
              <Route path='search' component={ClientsMapView} />
              <Route path='search/:mapID' component={ClientsMapView} />
            </Route>

            <Route path='client' component={ClientContainer}>
              <Route path=':id' component={ClientView} />
              <Route path=':id/tasks' component={ClientTasks} />
              <Route path=':id/interactions' component={ClientInteractions} />
              <Route path=':id/incidents' component={ClientDamageIncidents}>
                <Route path=':incidentId' component={ClientDamageIncidents} />
              </Route>
              <Route path=':id/permissions' component={ClientPermissions} />
              <Route path=':id/jobs' component={ClientJobs} />
              <Route path=':id/job/:job' component={JobView} />
              <Route path=':id/incident/:incident' component={ClientIncident} />
              {/*
              <Route path=':id/tasks' component={} />
              <Route path=':id/jobs' component={} />
              <Route path=':id/edit' component={} />
              <Route path=':id/incidents' component={} />
              */}
            </Route>
            <Route path='opportunities' component={JobsContainer} />
            <Route path='opportunities/:id' component={JobsContainer} />
            <Route path='opportunities-table' component={OpportunitiesContainer} />
            <Route path='opportunities-table/:id' component={OpportunitiesContainer} />
            <Route path='clients/upload' component={ClientsUpload} />
            <Route path='clients/settings' component={ClientsSettingsView}>
              <IndexRoute components={FieldSettings} />
              {/*<Route path='pipeline' component={ClientsPipelineSettings} />*/}
              <Route path='fields' component={FieldSettings} />
              <Route path='types' component={TypeSettings} />
              <Route path='pipeline-builder' component={PipelineBuilderSettings} />
            </Route>
            <Route path='clients' component={ClientsContainer}>
              <IndexRoute component={ClientsListView} />
              <Route path='map' component={ClientsMapView} />
              <Route path='map/:mapID' component={ClientsMapView} />
              <Route path='canvassing' component={ClientsMapView} />
            </Route>
            <Route path="live-weather-center" component={LiveWeatherCenter}/>
            <Route path='plans' component={PlansContainer}/>
            <Route path='reports' component={ReportsContainer}>
              <IndexRedirect to='canvassing-report' component={CanvassingReport} />
              <Route path='canvassing-report' component={CanvassingReport} />
            </Route>
            <Route path='settings' component={SettingsContainer}>
              <Route path='integrations' component={IntegrationsContainer} />
              <Route path='notification-settings' component={NotificationSettingsContainer} />
            </Route>
            <Route path='settings/subscriptions' component={SubscriptionsContainer} />
            <Route path='settings/subscriptions/view-details' component={SubscriptionDetailsView} />
            <Route path='settings/subscriptions/wizard' component={SubscriptionWizardContainer} />
            <Route path='permissions' component={PermissionsContainer} />

            <Route path='error-logs' component={ErrorLogsContainer} />

            <Route path='help' component={HelpContainer} />
            <Route path='*' component={Route404} />
          </Route>
        </Router>
      </Provider>
    ),
    entry
  );
  }
  catch(e) {
    console.error(e);
  }

}



// WEBPACK FOOTER //
// ./src/browser/main.js